var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxTicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#57BD83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6418 6.48404L19.6418 6.48402C19.2395 6.07927 18.5853 6.07727 18.1805 6.47959L9.4808 15.1266L5.81942 11.4892L5.81942 11.4892C5.41454 11.087 4.76028 11.0892 4.35807 11.494C3.95585 11.8989 3.95802 12.5531 4.36286 12.9554L4.36287 12.9554L8.75271 17.3164C9.15577 17.7169 9.80649 17.7168 10.2094 17.3162L19.6374 7.94537C20.0422 7.54306 20.0441 6.8888 19.6418 6.48404Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTicked);
export default __webpack_public_path__ + "static/media/checkbox-ticked.3abea44d12a65c1428fee473cd2fa75c.svg";
export { ForwardRef as ReactComponent };